/**
 * Curated list of common vehicle makes/models for the Marque/Modèle dropdowns.
 * Not exhaustive by design — ConfirmableAutocomplete lets staff add anything missing,
 * and confirmed additions are persisted server-side (see vehiclesApi.getMakes/getModels).
 */
export const CAR_MAKES_MODELS: Record<string, string[]> = {
  Renault: ['Clio', 'Megane', 'Twingo', 'Captur', 'Kadjar', 'Scenic', 'Talisman', 'Trafic', 'Master', 'Kangoo', 'Symbol', 'Duster', 'Express'],
  Peugeot: ['208', '308', '2008', '3008', '5008', '108', '508', '407', '206', '207', 'Partner', 'Boxer', 'Expert'],
  Citroën: ['C3', 'C4', 'C5', 'C1', 'Berlingo', 'C3 Aircross', 'C5 Aircross', 'Jumpy', 'Jumper', 'Xsara', 'Picasso'],
  DS: ['DS3', 'DS4', 'DS5', 'DS7 Crossback', 'DS9'],
  Dacia: ['Logan', 'Sandero', 'Duster', 'Lodgy', 'Dokker', 'Spring'],
  Volkswagen: ['Golf', 'Polo', 'Passat', 'Tiguan', 'Touareg', 'Jetta', 'Caddy', 'Transporter', 'T-Roc', 'Up!', 'Arteon'],
  Toyota: ['Corolla', 'Yaris', 'RAV4', 'Camry', 'Land Cruiser', 'Hilux', 'Auris', 'Avensis', 'C-HR', 'Prius', 'Fortuner'],
  Hyundai: ['i10', 'i20', 'i30', 'Tucson', 'Santa Fe', 'Accent', 'Elantra', 'Kona', 'Creta', 'H1'],
  Kia: ['Picanto', 'Rio', 'Ceed', 'Sportage', 'Sorento', 'Cerato', 'Sonet', 'Seltos', 'Carnival'],
  Ford: ['Fiesta', 'Focus', 'Kuga', 'Mondeo', 'EcoSport', 'Transit', 'Ranger', 'Puma', 'Explorer'],
  Fiat: ['Panda', '500', 'Tipo', 'Punto', 'Doblo', 'Ducato', '500X', 'Talento'],
  Opel: ['Corsa', 'Astra', 'Insignia', 'Mokka', 'Grandland', 'Combo', 'Crossland', 'Vivaro'],
  Nissan: ['Micra', 'Qashqai', 'Juke', 'X-Trail', 'Navara', 'Note', 'Sunny', 'Patrol', 'Sentra'],
  'Mercedes-Benz': ['Classe A', 'Classe C', 'Classe E', 'Classe S', 'GLA', 'GLC', 'GLE', 'CLA', 'Vito', 'Sprinter'],
  BMW: ['Série 1', 'Série 2', 'Série 3', 'Série 4', 'Série 5', 'X1', 'X3', 'X5', 'X6', 'Z4'],
  Audi: ['A1', 'A3', 'A4', 'A5', 'A6', 'Q2', 'Q3', 'Q5', 'Q7', 'TT'],
  Škoda: ['Fabia', 'Octavia', 'Superb', 'Kodiaq', 'Karoq', 'Rapid', 'Scala'],
  Seat: ['Ibiza', 'Leon', 'Arona', 'Ateca', 'Tarraco', 'Alhambra'],
  Suzuki: ['Swift', 'Vitara', 'Jimny', 'Baleno', 'S-Cross', 'Celerio', 'Ertiga'],
  Chevrolet: ['Aveo', 'Cruze', 'Spark', 'Captiva', 'Malibu', 'Trailblazer'],
  Honda: ['Civic', 'CR-V', 'Accord', 'Jazz', 'HR-V', 'City'],
  Mazda: ['Mazda2', 'Mazda3', 'Mazda6', 'CX-3', 'CX-5', 'CX-30'],
  Mitsubishi: ['Pajero', 'Outlander', 'ASX', 'L200', 'Lancer', 'Eclipse Cross'],
  Jeep: ['Renegade', 'Compass', 'Cherokee', 'Grand Cherokee', 'Wrangler'],
  'Land Rover': ['Range Rover', 'Range Rover Evoque', 'Range Rover Sport', 'Discovery', 'Defender'],
  Volvo: ['XC40', 'XC60', 'XC90', 'S60', 'V40', 'V60'],
  Mini: ['Cooper', 'Countryman', 'Clubman', 'Cabrio'],
  Porsche: ['911', 'Cayenne', 'Macan', 'Panamera', 'Taycan'],
  'Alfa Romeo': ['Giulietta', 'Giulia', 'Stelvio', 'MiTo'],
  Chery: ['Tiggo 7', 'Tiggo 8', 'Arrizo 5', 'QQ'],
  Changan: ['CS35', 'CS75', 'Alsvin', 'Eado'],
  MG: ['MG3', 'MG5', 'ZS', 'HS'],
  Geely: ['Coolray', 'Emgrand', 'Azkarra'],
  Lexus: ['RX', 'NX', 'ES', 'IS', 'LX'],
  Isuzu: ['D-Max', 'MU-X'],
  Iveco: ['Daily', 'Eurocargo'],
  'Great Wall / Haval': ['H6', 'Jolion', 'H2'],
  SsangYong: ['Korando', 'Tivoli', 'Rexton'],
  Jaguar: ['XE', 'XF', 'F-Pace', 'E-Pace'],
  Smart: ['Fortwo', 'Forfour'],
  Subaru: ['Forester', 'Outback', 'XV', 'Impreza'],
}

export const CAR_MAKES: string[] = Object.keys(CAR_MAKES_MODELS).sort((a, b) => a.localeCompare(b))
